import {
    VENDOR_ADD_TEAM_TABLE_REQUEST,
    VENDOR_ADD_TEAM_TABLE_SUCCESS,
    VENDOR_ADD_TEAM_TABLE_FAIL
  } from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    action: "Job Action",
    result: null,
    msg: "",
    error: "",
  };
  
  const VendorTeamTableReducer = (state = initialState, action) => {
    switch (action.type) {
      case VENDOR_ADD_TEAM_TABLE_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case VENDOR_ADD_TEAM_TABLE_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case VENDOR_ADD_TEAM_TABLE_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default VendorTeamTableReducer;
  